'use client';

import { ROOM_TYPES } from '@/entities/visit-counsel/model/house-sketch.types';

/** 방 타입(RoomType) + 이동수단/추가공간(AdditionalSpaceType 등) 직렬화명 → 표시명. 서버 SpaceType.kor와 동일 */
const ROOM_TYPE_LABEL_MAP: Record<string, string> = Object.fromEntries(
  ROOM_TYPES.map((r) => [r.value, r.label])
);

export const SPACE_TYPE_LABELS: Record<string, string> = {
  ...ROOM_TYPE_LABEL_MAP,
  /** 인테이크 이동수단 등 (MovingMethodType) */
  ELEVATOR: '엘리베이터',
  LADDER_TRUCK: '사다리차',
  SKY_LIFT: '스카이',
  STAIR: '계단',
  FIRST_FLOOR: '1층',
  /** AdditionalSpaceType — 서버 AdditionalSpaceType.kor */
  LADDER_TRUCK_ENTRANCE: '사다리차 진입로(집 내부)',
  FIRST_FLOOR_TRUCK_ENTRANCE: '사다리차 진입로(1층)',
  STAIRS: '계단',
};
